import { useCallback } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { formatDocumentTitle } from '@/lib/document-title';
import { BusinessSetupPageShell } from './business-setup/components/business-setup-page-shell';
import { CallsPageContent } from './calls/calls-page-content';
import { parseCallsPageSearch, type CallsPageTab } from './calls/calls-page-search';

export const Route = createFileRoute('/_auth/$orgId/settings/calls')({
  validateSearch: parseCallsPageSearch,
  component: CallsSettingsRoute,
});

function CallsSettingsRoute() {
  const { orgId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();
  // Replace, not push: flipping through tabs should not fill the back button with them.
  const selectTab = useCallback(
    (next: CallsPageTab) => void navigate({ search: (prev) => ({ ...prev, tab: next }), replace: true }),
    [navigate]
  );

  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Calls & AI Assistant')}</title>
      </Helmet>
      <BusinessSetupPageShell orgId={orgId} activePath="calls">
        <CallsPageContent orgId={orgId} tab={tab} onSelectTab={selectTab} />
      </BusinessSetupPageShell>
    </>
  );
}
